// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__1hMFd","icons":"LoadingScreen_icons__2jrUq"};